import { z } from "zod";

export default z.object({ "date": z.string().describe("일자"), "type": z.string().describe("누락 종류") }).describe("근태 관리 누락");
